import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import jwtDecode from 'jwt-decode';
import brandLogo from '../assets/brandLogo.png';
import url from '../constants/config';
import { setUserEmail, setUserRole, setIsProfileFinished } from '../shared/store/authSlice';

const AssistantSetupPage = ({ setIsAuthorized }) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const params = new URLSearchParams(location.search);
  const inviteToken = params.get('invite');
  const inviteEmail = params.get('email') || '';

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (!password || !confirmPassword) {
      setError('Wypełnij wszystkie pola.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Hasła nie są identyczne.');
      return;
    }
    if (password.length < 8) {
      setError('Hasło musi mieć co najmniej 8 znaków.');
      return;
    }
    setLoading(true);
    try {
      const result = await axios.post(`${url}/users/claim-invite`, {
        inviteToken,
        email: inviteEmail,
        password,
      });
      const token = result.headers.authorization;
      window.localStorage.setItem('authorization', token);
      const decoded = jwtDecode(token);
      dispatch(setUserRole('assistant'));
      dispatch(setIsProfileFinished(true));
      dispatch(setUserEmail(decoded.email));
      if (setIsAuthorized) setIsAuthorized(true);
      history.push('/admin/assistant-dashboard');
    } catch (err) {
      setError(
        err.response?.data?.message || 'Błąd aktywacji. Link może być nieważny lub wygasły.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#f8fafc',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
      }}
    >
      <div
        style={{
          background: '#ffffff',
          borderRadius: '12px',
          boxShadow: '0 2px 16px rgba(0,0,0,0.08)',
          padding: '40px',
          width: '100%',
          maxWidth: '400px',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img src={brandLogo} alt="PlaySportUSA" style={{ height: '40px', marginBottom: '16px' }} />
          <h2 style={{ margin: '0 0 8px', color: '#1e293b', fontSize: '20px' }}>
            Aktywuj konto
          </h2>
          <p style={{ margin: 0, color: '#64748b', fontSize: '14px' }}>
            Ustaw hasło, aby aktywować konto.
          </p>
          {inviteEmail && (
            <p style={{ margin: '8px 0 0', color: '#94a3b8', fontSize: '13px' }}>
              {inviteEmail}
            </p>
          )}
        </div>

        {error && (
          <div
            style={{
              background: '#fef2f2',
              border: '1px solid #fca5a5',
              borderRadius: '8px',
              padding: '12px',
              marginBottom: '16px',
              color: '#dc2626',
              fontSize: '14px',
            }}
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label
              htmlFor="assistant-password"
              style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600', color: '#374151' }}
            >
              Hasło
            </label>
            <input
              id="assistant-password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #d1d5db',
                borderRadius: '8px',
                fontSize: '14px',
                boxSizing: 'border-box',
              }}
              required
            />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label
              htmlFor="assistant-confirm-password"
              style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600', color: '#374151' }}
            >
              Potwierdź hasło
            </label>
            <input
              id="assistant-confirm-password"
              type="password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #d1d5db',
                borderRadius: '8px',
                fontSize: '14px',
                boxSizing: 'border-box',
              }}
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              background: '#2e496b',
              color: '#ffffff',
              border: 'none',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? 'Aktywowanie...' : 'Aktywuj konto'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AssistantSetupPage;
